// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"c95287cf","513":"1e737f1e","636":"4497ebe5","703":"d360e1e6","787":"1a2d2076","938":"b344a6ab"}[chunkId] + ".chunk.js";
};